import React from "react";
import { Spinner } from "react-bootstrap";

const SecondaryButton = (props) => {
  let {
    text,
    width,
    height,
    radius,
    type,
    btnColor,
    txtcolor,
    handleClick,
    disabled,
    customClass,
    borderColor,
    icon,
    rightIcon,
    isSubmitting,
  } = props;
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={handleClick}
      style={{
        width: width,
        height: height,
        color: txtcolor,
        borderRadius: radius,
        backgroundColor: btnColor || "#33c1c0",
        border: `1px solid ${borderColor || btnColor}`,
      }}
      className={customClass || "secondary-btn"}
    >
      {icon && (
        <img
          height="18px"
          width="18px"
          src={icon}
          alt="btn-icon"
          style={{ marginRight: "5px" }}
        />
      )}
      {text?.length > 0 && text}
      {type === "submit" && isSubmitting ? (
        <>
          &nbsp;{" "}
          <Spinner
            as="div"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        </>
      ) : (
        rightIcon && (
          <>
            &nbsp;{" "}
            <img height="18px" width="20px" src={rightIcon} alt="btn-icon" />
          </>
        )
      )}
    </button>
  );
};

export default SecondaryButton;
